import dataModel from '../../models/DataModel.js';
import AnalyticsLogger from '../../helpers/analytics/analyticsLogger.js';

export class OfflineQueue
{

  constructor() {
    this.processingQueue = false;
  }

  getKey() {
    return 'OFFLINE_QUEUE';
  }

  getData(){
    return this.data;
  }

  hasData(){
    let queue = this.findCollection();
    if(queue && queue.queueItems && queue.queueItems.length > 0) {
      return true;
    }
    return false;
  }

  findCollection() {
    return dataModel.collectionsDAO.findCollection(this.getKey());
  }

  setCollection(offlineQueueCollection) {
    return dataModel.collectionsDAO.DAO.setCollection();
  }

  processQueueItem(queueItem) {
    switch (queueItem.itemKey) {
    case 'completion_criterion':
      return dataModel.completionCriteriaDAO.completeOfflineUpdate(queueItem);
    case 'task':
      return dataModel.tasksDAO.completeOfflineUpdate(queueItem);
    case 'build':
      return dataModel.buildsDAO.completeOfflineUpdate(queueItem);
    case 'project':
      return dataModel.projectsDAO.completeOfflineUpdate(queueItem);
    case 'attachment':
      return dataModel.attachmentsDAO.completeOfflineUpdate(queueItem);
    case 'inventoryItem':
      return dataModel.inventoryItemsDAO.completeOfflineUpdate(queueItem);
    case 'comment':
      return dataModel.commentsDAO.completeOfflineUpdate(queueItem);
    case 'analytics':
      return this.analyticsLogger.completeOfflineUpdate(queueItem);
    case 'form_field':
      return dataModel.formFieldsDAO.completeOfflineUpdate(queueItem);
    case 'support_request':
      return dataModel.supportRequestsDAO.completeOfflineUpdate(queueItem);
    case 'closeout':
      return dataModel.closeoutsDAO.completeOfflineUpdate(queueItem);
    default:
      return Promise.resolve();
    }
  }

  async processQueue() { 
    if (this.processingQueue) {
      return false;
    }
    this.processingQueue = true;
    let updatedData = false;
    try {
      if (!this.analyticsLogger) {
        const currentRole = dataModel.usersDAO.currentUser ? dataModel.usersDAO.currentUser.role : null;
        this.analyticsLogger = new AnalyticsLogger({
          currentRole,
          isMobile: !!window.cordova,
        });
      }
      // do a copy of the queue, so we don't get in and endless loop if one of them fails
      const foundQueue = this.findCollection();
      let queue = Object.assign({}, foundQueue);
      while (queue && queue.queueItems && queue.queueItems.length > 0 && !dataModel.isOffline) {
        const queueItem = queue.queueItems.shift();
        if (queueItem) {
          if (queueItem.itemKey != 'analytics') {
            updatedData = true;
          }
          try {
            await this.processQueueItem(queueItem);
          } catch (error) {
            // TODO
          }
        }
      }
    } finally {
      this.processingQueue = false;
    }
    return(updatedData);
  }

  addQueueItem(itemKey, operationKey, itemInfo) {
    let queue = this.findCollection();
    if (!queue) {
      queue = { queueItems: [] };
    }
    queue.queueItems.push({ itemKey, operationKey, itemInfo, status: 'pending' });
    this.data = queue;
    console.log(queue);
    dataModel.collectionsDAO.setCollection(this.getKey(), queue, 'offlineQueue');
    if(!dataModel.isOffline){
      this.processQueueItem(queue.queueItems.shift());
    }
  }
}

export default new OfflineQueue();



// WEBPACK FOOTER //
// ./src/dao/queue/OfflineQueue.js